import { render, staticRenderFns } from "./NewUserCreate.vue?vue&type=template&id=4e72e5be&"
import script from "./NewUserCreate.vue?vue&type=script&lang=js&"
export * from "./NewUserCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports